import { select, put, call, takeEvery, takeLatest} from "redux-saga/effects";
import { GWatcher } from "types/redux";
import { Vitals } from "types/entity";
import { ADD_VITALS, CREATE_VITALS, UNSET_VITALS_BY_TYPE_REDUCER } from "containers/Profile/services/constants";
import { GET_VITALS_BY_TYPE, RESET_VITALS, SET_CHECKUP_VITALS, SET_VITALS_STEP } from "./constants";
import { request } from "lib/request";
import { getCurrentSelectedPatientId } from "containers/Survey/services/selector";
import { getCustomer } from "client/services/selector";
import {
  customerIdentity,
  persistVitalsSnapshot,
} from "containers/Survey/services/surveyStorage";
import { VitalsStore } from "types/store";
import actions from "./action";

function* createVitals({ payload }: { type: string, payload: any}) {
  const relative_id = yield select(getCurrentSelectedPatientId);
  try {
    const res = yield request('/vitals/customers/create', { method: 'POST', payload: {...payload, relative_id: relative_id === 0 ? null : relative_id } })
    yield put(actions.addVitals({ value: res?.vital.value, type: res?.vital?.type, id: res.vital.id}, res.vital?.relative_id ? res.vital?.relative_id : 0))
  } catch(error) {
    console.error(error, {
      route: 'vitals/customers/create',
    })
  }
}

function* getVitalsByType({ payload } : { type: string, payload: Vitals}) {
  try {
    const res = yield request(`/vitals/customers/${payload.type}/last${payload.relative_id ? '?relative_id='+payload.relative_id : ''}`, {
      method: 'GET'
    });
    if(res.status === 'ok' && res.vital) {
      const currentPatientId = res.vital?.relative_id ? res.vital?.relative_id : 0;
      yield put(actions.addVitals({ value: res.vital.value, type: res.vital.type, id: res.vital.id }, currentPatientId));
    }
  } catch(error) {
    console.error(error, {
      route: '/vitals/customer/last'
    })
  }
}

// Mirror the vitals recorded during the session in IndexedDB so a window
// reload restores them alongside the survey snapshot
function* syncVitalsStorage() {
  const vitals = yield select(
    ({ vitals }: { vitals: Partial<VitalsStore> }) => vitals,
  );
  const customer = yield select(getCustomer);
  yield call(persistVitalsSnapshot, vitals || {}, customerIdentity(customer));
}

function* VitalsWatcher(): GWatcher {
  yield takeEvery(CREATE_VITALS, createVitals);
  yield takeEvery(GET_VITALS_BY_TYPE, getVitalsByType);
  yield takeLatest(
    [ADD_VITALS, UNSET_VITALS_BY_TYPE_REDUCER, SET_VITALS_STEP, RESET_VITALS, SET_CHECKUP_VITALS],
    syncVitalsStorage,
  );
}

export default VitalsWatcher;